import * as React from 'react'
import Grid from '@material-ui/core/Grid';
import Star from '@material-ui/icons/Star';
import { localizations } from '../localization/localization';
import Typography from '@material-ui/core/Typography';
import GoldIcon from "../images/gold.svg";
import SilverIcon from "../images/silver.svg";
import BronzeIcon from "../images/bronze.svg";


interface CompanyActivityMarkProps {
    level: number;
    isCompany: boolean;
}

class CompanyActivityMark extends React.Component<CompanyActivityMarkProps,{}> {
    constructor(props: CompanyActivityMarkProps) {
        super(props);
    }

    public render() {
        const level = this.props.level || 0;
        const heading = localizations.common.announcementCount + ` ${level}`;

        return (
            <Grid container direction="column" alignItems="center" justify="flex-start" >
                {this.props.isCompany ? (<Typography paragraph variant="subtitle1">{heading}</Typography>) : null}
                <Grid container direction="row" justify="center" alignItems="center">
                    {level >= 100 && level < 500 ? (
                        <span>
                            <img src={BronzeIcon} width='32' height='32' />
                        </span>
                    ) : null}
                    {level >= 500 && level < 1500 ? (
                        <span>
                            <img src={SilverIcon} width='32' height='32' />
                        </span>
                    ) : null}
                    {level >= 1500 ? (
                        <span>
                            <img src={GoldIcon} width='32' height='32' />
                        </span>
                    ) : null}
                </Grid>
            </Grid>);
    }
}

export default CompanyActivityMark;


// WEBPACK FOOTER //
// ./src/common/companyActivityMark.tsx